export default __webpack_public_path__ + "static/home-video-poster-39e3d446dced60c09fa63bee096997c6.jpg";